export default __webpack_public_path__ + "static/media/SNX-ETH.3f892731.png";